export const ExpenseDefaultLogo = ({ label }: { label: string }) => {
  return (
    <div className="size-8 rounded-md bg-gray-200 dark:bg-gray-600 flex items-center justify-center flex-shrink-0">
      <span className="text-xs font-semibold text-gray-700 dark:text-gray-200">
        {(() => {
          const words = label.split(" ").filter((word) => word.length > 0);
          if (words.length >= 2) {
            return words.slice(0, 2).map((word) => word[0]).join("").toUpperCase();
          }
          return label.slice(0, 2).toUpperCase();
        })()}
      </span>
    </div>
  );
};
